import type {FC} from 'react';
import LazyLoading from '@/components/common/LazyLoading';
import ForestMassDetail from '@/components/ForestMassDetail';
import {useController} from './controller';

const ForestMassDetailView: FC = () => {
  const {
    forestMass,
    forestMassStatus,
    forestMassSpecies,
    appraisers,
    species,
    selectedSpecies,
    inventoryPlots,
    userPermissions,
    businessLogic,
    lidarTechnologies,
    uavPointCloud,
    loading,
    onUpdateForestMass,
    onCutForestMass,
    onBack,
    onInventoryPlotSelect,
    onDownloadGeopackage,
    onSpeciesChange,
    onUploadInventoryPlot,
    onUploadUavPointCloud,
    onDeleteUavPointCloud,
    onDownloadUavPointCloud,
    onReuploadUavPointCloud,
  } = useController();

  return (
    <>
      {loading && <LazyLoading />}
      {forestMass && forestMassStatus && businessLogic && (
        <ForestMassDetail
          forestMass={forestMass}
          forestMassStatus={forestMassStatus}
          forestMassSpecies={forestMassSpecies}
          appraisers={appraisers}
          species={species}
          selectedSpecies={selectedSpecies}
          lidarTechnologies={lidarTechnologies}
          uavPointCloud={uavPointCloud}
          inventoryPlots={inventoryPlots}
          permissions={userPermissions}
          businessLogic={businessLogic}
          onBack={onBack}
          onInventoryPlotSelect={onInventoryPlotSelect}
          onCutForestMass={onCutForestMass}
          onForestMassChange={onUpdateForestMass}
          onSelectedSpeciesChange={onSpeciesChange}
          onDownloadForestMass={onDownloadGeopackage}
          onUploadInventoryPlot={onUploadInventoryPlot}
          onUploadUavPointCloud={onUploadUavPointCloud}
          onDownloadUavPointCloud={onDownloadUavPointCloud}
          onReuploadUavPointCloud={onReuploadUavPointCloud}
          onDeleteUavPointCloud={onDeleteUavPointCloud}
        />
      )}
    </>
  );
};

export default ForestMassDetailView;
